// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GithubOutlinedSvg from "@fishx/icons-svg/es/asn/GithubOutlined";
import FishxIcon from '../components/FishxIcon';

var GithubOutlined = function GithubOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GithubOutlinedSvg
  }));
};

GithubOutlined.displayName = 'GithubOutlined';
export default React.forwardRef(GithubOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GithubOutlined.js
// module id = 2869
// module chunks = 0